// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_CriarReciboResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for criarRecibo() /compromissos/criarRecibo
 * Creates a PDF receipt for a compromisso via html2pdf-service
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Compromissos_CriarReciboResponseDados = string;

export type Compromissos_CriarReciboResponse = ApiResponse<Compromissos_CriarReciboResponseDados>;

registerResponseContract('Compromissos_CriarReciboResponse', {})
